import { Controller } from '@hotwired/stimulus'
import { ajaxCall, addOnlyOption, removeOptions } from '~/plugins/dropdowns/dynamic_dropdown_shared_functions'

export default class extends Controller {
  static targets = ['equipment', 'leak', 'averageKg', 'unit']

  get selectedEquipement() {
    return Array.from(this.equipmentTarget.options).find(opt => opt.selected).value
  }

  connect() {
    this.element.controller = this
  }

  updateDropdowns() {
    removeOptions(this.unitTarget)
    removeOptions(this.leakTarget)
    removeOptions(this.averageKgTarget)

    const url = '/dropdown_fugitive_units_leak_kg'
    const data = {
      selection: this.selectedEquipement,
      emission_item_db_name: this.dbNameTarget
    }

    // Stockage des resultats de la requete AJAX
    const response = ajaxCall(url, data)
    addOnlyOption(this.unitTarget, response['unit'])
    addOnlyOption(this.leakTarget, response['annual_leak_rate'])
    addOnlyOption(this.averageKgTarget, response['kg_fluid_per_unit'])
  }
}
